var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconLocationWavesNorthFill = function SvgIconLocationWavesNorthFill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.64,
    fillRule: "evenodd",
    d: "M10.882 11.675c.402-.97 1.828-.975 2.23 0l4.244 10.099-1.385.57-3.979-2.78-3.97 2.78-1.385-.571zM4.22 4.203c4.296-4.276 11.26-4.276 15.555 0a10.91 10.91 0 0 1 .671 14.75L19.24 17.75c2.94-3.632 2.719-8.979-.667-12.351-3.627-3.61-9.526-3.61-13.152 0-3.387 3.372-3.607 8.72-.667 12.352l-1.206 1.201A10.914 10.914 0 0 1 4.22 4.203M7.049 7.02c2.728-2.718 7.17-2.718 9.9-.001 2.488 2.478 2.7 6.368.65 9.096l-1.217-1.21a5.264 5.264 0 0 0-.635-6.688 5.324 5.324 0 0 0-7.496 0 5.265 5.265 0 0 0-.635 6.687L6.4 16.116c-2.05-2.728-1.84-6.618.65-9.096",
    clipRule: "evenodd"
  })));
};
export default SvgIconLocationWavesNorthFill;